jQuery(document).ready(() => {
    // console.log("Theme JS loaded");
    // Split text into spans
    if (jQuery("[text-split]").length) {
        let typeSplit = new SplitType("[text-split]", {
            types: "words, chars",
            tagName: "span",
        });
    }

    // Link timelines to scroll position
    function createScrollTrigger(triggerElement, timeline) {
        // Reset tl when scroll out of view past bottom of screen
        ScrollTrigger.create({
            trigger: triggerElement,
            start: "top bottom",
            onLeaveBack: () => {
                timeline.progress(0);
                timeline.pause();
            },
        });
        // Play tl when scrolled into view (60% from top of screen)
        ScrollTrigger.create({
            trigger: triggerElement,
            start: "top 60%",
            onEnter: () => timeline.play(),
        });
    }
    jQuery("[letters-fade-in]").each(function (index) {
        let tl = gsap.timeline({ paused: true });
        tl.from($(this).find(".char"), {
            opacity: 0,
            duration: 0.2,
            ease: "power1.out",
            stagger: { amount: 0.8 },
        });
        createScrollTrigger($(this), tl);
    });

    if (jQuery("[text-split]").length) {
        gsap.set("[text-split]", { opacity: 1 });
    }
});

function updateMenuWidth() {
    // Get the .header__link-list-wrap element
    var $menuWrap = $(".header__link-list");

    // Measure the width of the element
    var menuWidth = $menuWrap.width();

    // Add CSS variable to the element
    $menuWrap.attr("style", "--menu-container: " + menuWidth + "px");
}
$(window).resize(function () {
    updateMenuWidth();
});
// Convert all sheets
async function convertAllSheets(url) {
    try {
        const response = await fetch(url);
        const arrayBuffer = await response.arrayBuffer();

        const workbook = XLSX.read(arrayBuffer, { type: "array" });
        const allSheetsData = {};

        workbook.SheetNames.forEach((sheetName) => {
            const worksheet = workbook.Sheets[sheetName];
            const rawData = XLSX.utils.sheet_to_json(worksheet, {
                defval: "",
                raw: false,
            });

            // Process the data with custom formatting
            const processedData = processSheetData(rawData);
            allSheetsData[sheetName] = processedData;
        });

        // console.log(allSheetsData);
        return allSheetsData;
    } catch (error) {
        console.error("Error converting all sheets:", error);
    }
}

// Process sheet data with custom requirements
function processSheetData(rawData) {
    // Define allowed columns and their normalized names
    const allowedColumns = {
        "rim size": "rim-size",
        "tyre size": "tyre-size",
        ml: "ml",
        "us fl oz": "us-fl-oz",
        text: "text",
        "normal dosage litres": "normal-dosage-litres",
        "normal dosage us quart": "normal-dosage-us-quart",
        "severe dosage litres": "severe-dosage-litres",
        "severe dosage us quart": "severe-dosage-us-quart",
    };

    const processedData = [];

    rawData.forEach((row) => {
        const processedRow = {};
        let textContent = "";

        // Process each column
        Object.keys(row).forEach((originalKey) => {
            const normalizedKey = normalizeColumnName(originalKey);

            if (allowedColumns[normalizedKey]) {
                const finalKey = allowedColumns[normalizedKey];

                if (finalKey === "text") {
                    textContent = row[originalKey];
                } else {
                    processedRow[finalKey] = row[originalKey];
                }
            }
        });

        // Parse text content if exists
        if (textContent) {
            const parsedText = parseTextContent(textContent);
            Object.assign(processedRow, parsedText);
        }

        // Only add non-empty rows
        if (Object.keys(processedRow).length > 0) {
            processedData.push(processedRow);
        }
    });

    // Group by rim size
    const groupedData = groupByRimSize(processedData);

    return groupedData;
}

// Normalize column names
function normalizeColumnName(columnName) {
    return columnName
        .toLowerCase()
        .replace(/[^\w\s]/g, "") // Remove special characters except spaces
        .replace(/\s+/g, " ") // Normalize spaces
        .trim();
}

// Parse text content into separate fields
// Parse text content into separate fields
function parseTextContent(textContent) {
    const result = {};
    let isParsingTyreDescription = false;

    // Split by newlines and process each line
    const lines = textContent
        .split("\r\n")
        .map((line) => line.trim())
        .filter((line) => line);

    lines.forEach((line) => {
        // Check for different patterns
        if (line.startsWith("Product:")) {
            result["result-product"] = line.replace("Product:", "").trim();
            isParsingTyreDescription = false;
        } else if (line.startsWith("Tyre Size:")) {
            result["result-tyre-size"] = line.replace("Tyre Size:", "").trim();
            isParsingTyreDescription = false;
        } else if (line.startsWith("Tyre Description:")) {
            result["result-tyre-description"] = line.replace("Tyre Description:", "").trim();
            isParsingTyreDescription = true;
        } else if (line.startsWith("Dosage:")) {
            result["result-dosage"] = line.replace("Dosage:", "").trim();
            isParsingTyreDescription = false;
        } else if (line.startsWith("Normal Dosage:")) {
            result["result-normal-dosage"] = line.replace("Normal Dosage:", "").trim();
            isParsingTyreDescription = false;
        } else if (line.startsWith("Severe Dosage:")) {
            result["result-severe-dosage"] = line.replace("Severe Dosage:", "").trim();
            isParsingTyreDescription = false;
        }
        // Handle multi-line descriptions
        else if (isParsingTyreDescription) {
            // Add space if there's already content
            if (result["result-tyre-description"]) {
                result["result-tyre-description"] += " " + line;
            } else {
                result["result-tyre-description"] = line;
            }
        }
    });

    return result;
}

// Group data by rim size
function groupByRimSize(data) {
    const grouped = {};

    data.forEach((item) => {
        const rimSize = item["rim-size"] || "unknown";

        if (!grouped[rimSize]) {
            grouped[rimSize] = {
                "rim-size": rimSize,
                items: [],
            };
        }

        // Remove rim-size from individual product to avoid duplication
        const product = { ...item };
        delete product["rim-size"];

        grouped[rimSize].items.push(product);
    });

    // Convert to array format
    return Object.values(grouped);
}
function calcEvents(data) {
    jQuery(".select2-js").on("change", function () {
        var selectName = jQuery(this).attr("name");
        if (selectName == "product-type-select" || selectName == "mobile-product-type-select" || selectName == "inline-product-type-select") {
            if (selectName == "product-type-select") {
                jQuery(".calc-form-submit-desktop").addClass("disabled");
            } else if (selectName == "inline-product-type-select") {
                jQuery(".inline-calc-form-submit-desktop").addClass("disabled");
            } else {
                jQuery(".calc-form-submit-mobile").addClass("disabled");
            }

            let id = jQuery(this).val();
            let product = data[id];

            let rimMap = [];
            product.forEach((item) => {
                rimMap.push(item["rim-size"]);
            });
            if (selectName == "product-type-select") {
                rimSizeInit(rimMap, "sticky");
                jQuery(".calc-desktop.calc-desktop-sticky .calc-result-ml-oz").html("&#160;");
                jQuery(".calc-desktop.calc-desktop-sticky .dosage-label-second").html("");
                jQuery(".calc-desktop.calc-desktop-sticky .calc-result-ml-oz-second").html("");
                jQuery(".calc-desktop.calc-desktop-sticky .calc-result-product").html("");
                jQuery(".calc-desktop.calc-desktop-sticky .calc-result-rim-size").html("");
                jQuery(".calc-desktop.calc-desktop-sticky .calc-result-tyre-size").html("");
                jQuery(".calc-desktop.calc-desktop-sticky .calc-result-tyre-des").html("");
            }
            else if (selectName == "inline-product-type-select") {
                rimSizeInit(rimMap, "inline");
                jQuery(".inline-dosage-form .calc-desktop .calc-result-ml-oz").html("&#160;");
                jQuery(".inline-dosage-form .calc-desktop .dosage-label-second").html("");
                jQuery(".inline-dosage-form .calc-desktop .calc-result-ml-oz-second").html("");
                jQuery(".inline-dosage-form .calc-desktop .calc-result-product").html("");
                jQuery(".inline-dosage-form .calc-desktop .calc-result-rim-size").html("");
                jQuery(".inline-dosage-form .calc-desktop .calc-result-tyre-size").html("");
                jQuery(".inline-dosage-form .calc-desktop .calc-result-tyre-des").html("");
            } else {
                rimSizeInit(rimMap, "mobile");
                jQuery(".calc-mobile .calc-result-ml-oz").html("&#160;");
                jQuery(".calc-mobile .dosage-label-second").html("");
                jQuery(".calc-mobile .calc-result-ml-oz-second").html("");
                jQuery(".calc-mobile .calc-result-product").html("");
                jQuery(".calc-mobile .calc-result-rim-size").html("");
                jQuery(".calc-mobile .calc-result-tyre-size").html("");
                jQuery(".calc-mobile .calc-result-tyre-des").html("");
            }
        } else if (selectName == "rim-size-select" || selectName == "mobile-rim-size-select" || selectName == "inline-rim-size-select") {
            let id = jQuery(this).val();
            var productSelected = "";
            if (selectName == "rim-size-select") {
                let productTypeSelect = jQuery("select[name='product-type-select']");
                productSelected = productTypeSelect.val();
                jQuery(".calc-form-submit-desktop").addClass("disabled");
            }
            else if (selectName == "inline-rim-size-select") {
                let productTypeSelect = jQuery("select[name='inline-product-type-select']");
                productSelected = productTypeSelect.val();
                jQuery(".inline-calc-form-submit-desktop").addClass("disabled");
            } else {
                let productTypeSelect = jQuery("select[name='mobile-product-type-select']");
                productSelected = productTypeSelect.val();
                jQuery(".calc-form-submit-mobile").addClass("disabled");
            }
            
            let product = data[productSelected];

            let rimSize = product.find(function (item) {
                return item["rim-size"] == id;
            });
            let items = rimSize.items;
            if (selectName == "rim-size-select") {
                tyreSizeInit(items, "sticky");
            }
            else if (selectName == "inline-rim-size-select") {
                tyreSizeInit(items, "inline");
            } else {
                tyreSizeInit(items, "mobile");
            }
        } else if (selectName == "find-dealer-select") {
            let id = jQuery(this).val();
            let calcData = JSON.parse(window.findDealerData);
            let dealer = calcData.dealers.find(function (item) {
                return item.id == id;
            });
            showDealer(dealer);
        } else if (selectName == "instructions-select") {
            let id = jQuery(this).val();
            let calcData = window.instructionsData;
            let instruction = calcData.instructions.find(function (item) {
                return item.id == id;
            });
            initInstructionsSlider(instruction);
        } else {
            if (selectName == "tyre-size-select") {
                jQuery(".calc-form-submit-desktop").removeClass("disabled");
            } else if (selectName == "inline-tyre-size-select") {
                jQuery(".inline-calc-form-submit-desktop").removeClass("disabled");
            } else {
                jQuery(".calc-form-submit-mobile").removeClass("disabled");
            }
        }
    });

    jQuery(document).on("click", ".calc-form-submit", function () {
        if (jQuery(this).hasClass("calc-form-submit-desktop")) {
            jQuery(".calc-desktop-sticky .calc-desktop-bottom").slideDown();
            jQuery(".calc-desktop.calc-desktop-sticky").addClass("is-show-result");

            var productTypeSelect = jQuery("select[name='product-type-select']").val();
            var rimSizeSelect = jQuery("select[name='rim-size-select']").val();
            var tyreSizeSelect = jQuery("select[name='tyre-size-select']").val();

            calc(data, productTypeSelect, rimSizeSelect, tyreSizeSelect, "sticky");
        } else if (jQuery(this).hasClass("inline-calc-form-submit-desktop")) {
            jQuery(".inline-dosage-form .calc-desktop").addClass("is-show-result");

            var productTypeSelect = jQuery("select[name='inline-product-type-select']").val();
            var rimSizeSelect = jQuery("select[name='inline-rim-size-select']").val();
            var tyreSizeSelect = jQuery("select[name='inline-tyre-size-select']").val();
            calc(data, productTypeSelect, rimSizeSelect, tyreSizeSelect, "inline");
        } else {
            jQuery(".calc-mobile-bottom").slideDown();
            jQuery(".calc-mobile").addClass("is-show-result");

            var productTypeSelect = jQuery("select[name='mobile-product-type-select']").val();
            var rimSizeSelect = jQuery("select[name='mobile-rim-size-select']").val();
            var tyreSizeSelect = jQuery("select[name='mobile-tyre-size-select']").val();
            calc(data, productTypeSelect, rimSizeSelect, tyreSizeSelect, "mobile");
        }
    });
}
// MENU
$(document).ready(function () {
    updateMenuWidth();

    // Ensure GSAP and ScrollTrigger are registered
    gsap.registerPlugin(ScrollTrigger);

    // Required DOM elements
    const $header = $("header.shopify-section--header");
    const $menu = $(".header__main-nav");
    const $logo = $(".site-logo");
    const $logoText = $(".logo-main");
    const $logoO = $(".logo-o");

    // Variable to store previous scroll position to determine scroll direction
    let lastScrollTop = 0;

    // Function to calculate the shift distance for logo O
    function calculateLogoOShift() {
        const logoTextWidth = $logoText.outerWidth();
        const logoOWidth = $logoO.outerWidth();
        return -(logoTextWidth - logoOWidth); // Negative value to move left
    }

    // Phase 1: Add/remove class for header when scrolling
    ScrollTrigger.create({
        trigger: "body",
        start: "top top",
        end: "200px",
        scrub: true,
        onUpdate: function (self) {
            if (self.progress > 0) {
                $header.addClass("header-scrolled");
            } else {
                $header.removeClass("header-scrolled");
            }
        },
    });

    // Add scroll event to track scroll direction
    $(window).on("scroll", function () {
        const scrollTop = $(this).scrollTop();

        // Trigger point to activate the effect (600px)
        const triggerPoint = 600;

        // Determine scroll direction
        const isScrollingDown = scrollTop > lastScrollTop;

        // When scrolling down and passing the threshold
        if (isScrollingDown && scrollTop > triggerPoint) {
            // Hide menu and main logo, move logo O
            gsap.to($menu, {
                //opacity: 0,
                // y: -20,
                //pointerEvents: 'none',
                duration: 0.3,
                onComplete: function () {
                    // Add class when menu is hidden
                    $header.addClass("is-menu-hidden");
                },
            });

            gsap.to($logoText, {
                opacity: 0,
                width: 0,
                duration: 0.3,
            });

            gsap.to($logoO, {
                // x: calculateLogoOShift(),
                x: 0,
                duration: 0.3,
            });

            // Start rotating logo O if not already rotating
            if (!$logoO.data("rotating")) {
                gsap.to($logoO[0], {
                    rotation: 360,
                    duration: 20,
                    repeat: -1,
                    ease: "none",
                });
                $logoO.data("rotating", true);
            }
        }
        // When scrolling up (at any position)
        else if (!isScrollingDown) {
            // Show menu and main logo, return logo O to original position
            gsap.to($menu, {
                //opacity: 1,
                // y: 0,
                //pointerEvents: 'all',
                duration: 0.3,
                onStart: function () {
                    // Remove class when menu is shown
                    $header.removeClass("is-menu-hidden");
                },
            });

            gsap.to($logoText, {
                opacity: 1,
                width: "auto",
                duration: 0.3,
            });

            gsap.to($logoO, {
                x: 0,
                duration: 0.3,
            });

            // Stop rotating logo O
            if ($logoO.data("rotating")) {
                gsap.killTweensOf($logoO[0], { rotation: true });
                gsap.to($logoO[0], {
                    rotation: 0,
                    duration: 0.3,
                });
                $logoO.data("rotating", false);
            }
        }

        // Update previous scroll position
        lastScrollTop = scrollTop;
    });

    // Update values when window is resized
    $(window).on("resize", function () {
        // If logo O is in moved position, recalculate the distance
        if ($logoO.data("rotating")) {
            gsap.to($logoO, {
                x: 0,
                // x: calculateLogoOShift(),
                duration: 0.3,
            });
        }
    });

    jQuery(document).on("click", ".faqs-items:not(.faqs-tab-style) .faqs-item-head", function () {
        let head = jQuery(this);
        let item = head.parent();
        let body = item.find(".faqs-item-body-outer");
        let section = head.parents(".faqs-items");
        let isActive = item.hasClass("active");

        section.find(".faqs-item").removeClass("active");
        section.find(".faqs-item-body-outer").slideUp();
        if (isActive) {
            item.removeClass("active");
            body.slideUp();
        } else {
            item.addClass("active");
            body.slideDown();
        }
    });
    jQuery(document).on("click", ".tab-item-js", function () {
        let item = jQuery(this);
        let section = item.parents(".tab-js");
        let target = item.attr("data-target");

        section.find(".tab-item-js").removeClass("active");
        item.addClass("active");

        let targetElement = jQuery(target);
        let tabContent = targetElement.parents(".tab-js-target").find(".custom-tab-content");
        tabContent.css("display", "none");
        targetElement.css("display", "block");
    });
    jQuery(document).on("click", ".custom-tab-head-item:not(.active)", function () {
        let obj = jQuery(this);
        let target = obj.attr("data-target");
        obj.parent().find(".custom-tab-head-item").removeClass("active");
        obj.addClass("active");
        obj.parent().parent().find(".custom-tab-content-item").removeClass("active");
        obj.parent()
            .parent()
            .find(".custom-tab-content-item[data-id='" + target + "']")
            .addClass("active");
    });
    jQuery(document).on("click", ".custom-mobile-menu-lv-1 button.custom-mobile-menu-link", function () {
        let obj = jQuery(this);
        let title = obj.find("span").text();

        let pre_title = jQuery(".custom-mobile-menu-header-title").html();

        jQuery(".custom-mobile-menu-header-title").attr("data-pre-title", pre_title);
        jQuery(".custom-mobile-menu-header-title").html(title);

        jQuery(".custom-mobile-menu").addClass("is-show-sub-menu");
    });
    jQuery(document).on("click", ".custom-mobile-menu-back", function () {
        jQuery(".custom-mobile-menu-header-title").attr("data-pre-title", "");
        jQuery(".custom-mobile-menu-header-title").html("");
        jQuery(".custom-mobile-menu").removeClass("is-show-sub-menu");
    });
    jQuery(document).on("click", ".custom-mobile-menu-header button[is=menu-prev-button]", function () {
        let target = jQuery(".custom-mobile-menu-body").find(".panel-list__wrapper").children(".panel.is-active").children(".panel__wrapper:not(.is-hidden)").find(".custom-mobile-menu-back");
        target.trigger("click");
        jQuery(".calc-mobile").removeClass("active");
    });

    jQuery(document).on("click", ".menu-lv-3-toggle > .custom-mobile-menu-link", function (e) {
        e.preventDefault();
        let obj = jQuery(this);
        let li = obj.parent();
        let ul = obj.parent().parent();

        ul.children(".menu-lv-3-toggle").children(".custom-mobile-menu-lv-3").slideUp();
        if (li.hasClass("is-show-menu-lv-3")) {
            ul.children(".menu-lv-3-toggle").removeClass("is-show-menu-lv-3");
            li.removeClass("is-show-menu-lv-3");
            li.children(".custom-mobile-menu-lv-3").slideUp();
            ul.removeClass("ul-show-menu-lv-3");
        } else {
            ul.children(".menu-lv-3-toggle").removeClass("is-show-menu-lv-3");
            li.addClass("is-show-menu-lv-3");
            li.children(".custom-mobile-menu-lv-3").slideDown();
            ul.addClass("ul-show-menu-lv-3");
        }
    });

    //CALCULATOR
    jQuery(document).on("click", ".calc-desktop-toggle", function () {
        let target = jQuery(".calc-desktop.calc-desktop-sticky");
        target.toggleClass("active");
    });

    $(document).on("click", function (event) {
        if (!$(event.target).closest(".calc-desktop-sticky .calc-desktop-widget").length && !$(event.target).closest(".calc-desktop-sticky .calc-desktop-toggle").length) {
            $(".calc-desktop").removeClass("active");
        }
    });
    if (window.excelFileUrl != "" && window.excelFileUrl != undefined) {
        convertAllSheets(window.excelFileUrl).then((data) => {
            // console.log("data", data);
            
            // Filter out rim sizes 250 and 750 for "Off Road" key
            if (data["Off Road"]) {
                data["Off Road"] = data["Off Road"].filter(item => {
                    return item["rim-size"] !== "250" && item["rim-size"] !== "750";
                });
            }
            
            // Sort rim sizes from smallest to largest for each key
            Object.keys(data).forEach(key => {
                data[key].sort((a, b) => {
                    const rimSizeA = parseFloat(a["rim-size"]);
                    const rimSizeB = parseFloat(b["rim-size"]);
                    return rimSizeA - rimSizeB;
                });
            });
            
            productTypeInit(data);
        });
    }
    // productTypeInit();
    finDealerInit();
    instructionsInit();
    instructionsTabInit();

    jQuery(document).on("click", ".calc-mobile-toggle", function () {
        jQuery(".calc-mobile").toggleClass("active");
        jQuery(this).toggleClass("active");
    });
});

function finDealerInit() {
    if (window.findDealerData && Object.keys(window.findDealerData).length != 0) {
        //Desktop
        let findDealerSelect = jQuery("select[name='find-dealer-select']");
        findDealerSelect.html("");
        findDealerSelect.append("<option></option>");
        let calcData = JSON.parse(window.findDealerData);
        calcData.dealers.forEach(function (item, index) {
            let option = index == 0 ? '<option value="' + item.id + '" selected>' + item.title + "</option>" : '<option value="' + item.id + '">' + item.title + "</option>";
            findDealerSelect.append(option);
        });
        let dealer = calcData.dealers[0];
        showDealer(dealer);
        findDealerSelect.select2({
            dropdownParent: findDealerSelect.parent(),
            dropdownCssClass: "select2-dropdown-custom select2-dropdown-gray",
            minimumResultsForSearch: Infinity,
            templateResult: formatOption,
            templateSelection: formatOptionSelection,
            dropdownPosition: "below",
            placeholder: findDealerSelect.attr("data-placeholder"),
        });
    }
}
function showDealer(dealer) {
    jQuery(".find-dealer-title").html(dealer.title);
    jQuery(".find-dealer-content").html(dealer.content);
}

function instructionsInit() {
    if (window.instructionsData && Object.keys(window.instructionsData).length != 0) {
        //Desktop
        let instructionsSelect = jQuery("select[name='instructions-select']");
        instructionsSelect.html("");
        instructionsSelect.append("<option></option>");
        let calcData = window.instructionsData;
        calcData.instructions.forEach(function (item, index) {
            let option = index == 0 ? '<option value="' + item.id + '" selected>' + item.title + "</option>" : '<option value="' + item.id + '">' + item.title + "</option>";
            instructionsSelect.append(option);
        });
        let instruction = calcData.instructions[0];
        // showInstructions(dealer);
        instructionsSelect.select2({
            dropdownParent: instructionsSelect.parent(),
            dropdownCssClass: "select2-dropdown-custom select2-dropdown-primary",
            minimumResultsForSearch: Infinity,
            templateResult: formatOption,
            templateSelection: formatOptionSelection,
            dropdownPosition: "below",
            placeholder: instructionsSelect.attr("data-placeholder"),
        });
        initInstructionsSlider(instruction);
    }
}
const instructionsSliderElement = jQuery(".instructions-right .oko-free-images-slider");
const instructionsSlider = new Swiper(instructionsSliderElement[0], {
    // Optional parameters
    loop: false,
    slidesPerView: "auto",
    // freeMode: true,
    spaceBetween: 20,
    autoHeight: false,
    // If we need pagination
    pagination: {
        el: instructionsSliderElement.parents(".oko-free-images-slider-outer").find(".swiper-pagination")[0],
        clickable: true,
    },
    navigation: {
        nextEl: instructionsSliderElement.parents(".oko-free-images-slider-outer").find(".swiper-button-next")[0],
        prevEl: instructionsSliderElement.parents(".oko-free-images-slider-outer").find(".swiper-button-prev")[0],
    },
    on: {
        afterInit: function () {
            freeSliderItemWidth();
        },
        resize: function () {
            freeSliderItemWidth();
        },
        update: function () {
            freeSliderItemWidth();
        },
    },
});
function initInstructionsSlider(instructions) {
    // let height = jQuery('.oko-free-images-slider-main-inner').height();
    // jQuery('.oko-free-images-slider-main').css('height', height);

    instructionsSlider.removeAllSlides();
    instructionsSliderElement.addClass("is-updating");

    const newSlides = [];
    instructions.items.forEach(function (item, index) {
        let htmlItem = `<div class="swiper-slide">
                        <div class="oko-free-images-slider-item">
                            <div class="apply-images-slider-thumb">
                                <div class="apply-images-slider-image">
                                    <img src="${item.image}" alt="oko product slider" />
                                </div>
                            </div>
                            <div class="apply-images-slider-content">
                                <div class="apply-image-counter font-primary font-bold">${index + 1}</div>
                                <p class="apply-image-des font-secondary font-bold">${item.title}</p>
                            </div>
                        </div>
                    </div>`;
        newSlides.push(htmlItem);
    });
    instructionsSlider.appendSlide(newSlides);

    instructionsSlider.update();

    setTimeout(() => {
        instructionsSliderElement.removeClass("is-updating");
    }, 250);
}
function instructionsTabInit() {
    if (window.instructionsTabsData && Object.keys(window.instructionsTabsData).length != 0) {
        //Desktop
        let instructionsTabs = jQuery(".instructions-tab-outer .tab-js .tab-js-dynamic");
        let instructionsTable = jQuery(".instructions-table-outer .tab-js-target .tab-js-target-dynamic");
        instructionsTabs.html("");
        instructionsTable.html("");

        let calcData = window.instructionsTabsData;
        calcData.tabs.forEach(function (item, index) {
            // console.log(item);
            let activeClass = index == 0 ? "active" : "";
            let tabItem = `<div class="faqs-item tab-item-js ${activeClass}" data-target="#instructions-tab-${index}">
                            <div class="faqs-item-head">
                                <h3 class="faqs-item-title font-primary font-bold">${item.title}</h3>
                                <div class="faqs-item-icon">
                                    <svg width="32.06" height="32.062" viewBox="0 0 32.06 32.062">
                                        <defs>
                                            <clipPath id="star-clip-path">
                                                <path d="M0,18.186H32.06V-13.876H0Z" transform="translate(0 13.876)" fill="#f5fa00"></path>
                                            </clipPath>
                                        </defs>
                                        <g transform="translate(0 13.876)">
                                            <g transform="translate(0 -13.876)" clip-path="url(#star-clip-path)">
                                                <g transform="translate(0.001 0.001)">
                                                    <path d="M18.185,9.6H8.878a5.825,5.825,0,0,0-5.825,5.825v9.307h-1.8V15.427A5.825,5.825,0,0,0-4.57,9.6h-9.3V7.8h9.3A5.823,5.823,0,0,0,1.255,1.979v-9.3h1.8v9.3A5.823,5.823,0,0,0,8.878,7.8h9.307Z" transform="translate(13.875 7.326)" fill="#f5fa00"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </div>`;
            instructionsTabs.append(tabItem);

            let tabContentStyle = index == 0 ? "display: block;" : "display: none";

            const grouped = splitIntoThreeGroups(item.tyre_sizes);

            let groupHTML = ``;
            let headHTML = ``;
            grouped.map((group) => {
                const itemsHTML = group
                    .map((item) => {
                        return `<div class="instructions-tab-item-grid">
                                <div>${item.size}</div>
                                <div>${item.ml}</div>
                                <div>${item.oz}</div>
                            </div>`;
                    })
                    .join("");
                headHTML = `<div class="instructions-tab-item-grid">
                                <div>${calcData.config.tyre_sizes_title}</div>
                                <div>${calcData.config.ml_title}</div>
                                <div>${calcData.config.oz_title}</div>
                            </div>`;
                groupHTML = groupHTML + `<div class="instructions-tab-items-grid">${itemsHTML}</div>`;
            });
            let finalTab = `<div class="instructions-tab-grid-outer custom-scrollbar">
                                <div class="instructions-tab-grid is-head">${headHTML}${headHTML}${headHTML}</div>
                                <div class="instructions-tab-grid">${groupHTML}</div>
                            </div>`;
            let tableItem = `<div class="custom-tab-content" id="instructions-tab-${index}" style="${tabContentStyle}">${finalTab}</div>`;
            instructionsTable.append(tableItem);
        });
    }
}
function splitIntoThreeGroups(array) {
    const result = [[], [], []];
    array.forEach((item, index) => {
        result[index % 3].push(item);
    });
    return result;
}
function chunkArray(array, size) {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
    }
    return result;
}

function formatOption(option) {
    if (!option.id) {
        return option.text;
    }
    var description = $(option.element).data("description");
    if (description && description != "") {
        var $option = $('<div class="select2-option">' + '<div class="select2-option-text">' + option.text + "</div>" + '<div class="select2-option-description">' + description + "</div>" + "</div>");
    } else {
        var $option = $('<div class="select2-option">' + '<div class="select2-option-text">' + option.text + "</div>" + "</div>");
    }

    return $option;
}
function formatOptionSelection(option) {
    return option.text;
}

// Show result
function calc(data, productTypeSelect, rimSizeSelect, tyreSizeSelect, type) {
    let product = data[productTypeSelect];

    let rimSize = product.find(function (item) {
        return item["rim-size"] == rimSizeSelect;
    });
    let items = rimSize.items;

    var tyreSize = items.find(function (item) {
        return item["tyre-size"] == tyreSizeSelect;
    });

    // console.log("tyreSize", tyreSize);

    let firstDosageTarget;
    if (type == "mobile") {
        firstDosageTarget = jQuery(".calc-mobile .dosage-label");
    } else if (type == "sticky") {
        firstDosageTarget = jQuery(".calc-desktop.calc-desktop-sticky .dosage-label");
    } else {
        firstDosageTarget = jQuery(".inline-dosage-form .calc-desktop .dosage-label");
    }
    let secondDosageTarget;
    if (type == "mobile") {
        secondDosageTarget = jQuery(".calc-mobile .dosage-label-second");
    } else if (type == "sticky") {
        secondDosageTarget = jQuery(".calc-desktop.calc-desktop-sticky .dosage-label-second");
    } else {
        secondDosageTarget = jQuery(".inline-dosage-form .calc-desktop .dosage-label-second");
    }

    let firstVolumeTarget;
    if (type == "mobile") {
        firstVolumeTarget = jQuery(".calc-mobile .calc-result-ml-oz");
    } else if (type == "sticky") {
        firstVolumeTarget = jQuery(".calc-desktop.calc-desktop-sticky .calc-result-ml-oz");
    } else {
        firstVolumeTarget = jQuery(".inline-dosage-form .calc-desktop .calc-result-ml-oz");
    }
    let secondVolumeTarget;
    if (type == "mobile") {
        secondVolumeTarget = jQuery(".calc-mobile .calc-result-ml-oz-second");
    } else if (type == "sticky") {
        secondVolumeTarget = jQuery(".calc-desktop.calc-desktop-sticky .calc-result-ml-oz-second");
    } else {
        secondVolumeTarget = jQuery(".inline-dosage-form .calc-desktop .calc-result-ml-oz-second");
    }
    let productTarget;
    if (type == "mobile") {
        productTarget = jQuery(".calc-mobile .calc-result-product");
    } else if (type == "sticky") {
        productTarget = jQuery(".calc-desktop.calc-desktop-sticky .calc-result-product");
    } else {
        productTarget = jQuery(".inline-dosage-form .calc-desktop .calc-result-product");
    }

    let rimSizeTarget;
    if (type == "mobile") {
        rimSizeTarget = jQuery(".calc-mobile .calc-result-rim-size");
    } else if (type == "sticky") {
        rimSizeTarget = jQuery(".calc-desktop.calc-desktop-sticky .calc-result-rim-size");
    } else {
        rimSizeTarget = jQuery(".inline-dosage-form .calc-desktop .calc-result-rim-size");
    }

    let tyreSizeTarget;
    if (type == "mobile") {
        tyreSizeTarget = jQuery(".calc-mobile .calc-result-tyre-size");
    } else if (type == "sticky") {
        tyreSizeTarget = jQuery(".calc-desktop.calc-desktop-sticky .calc-result-tyre-size");
    } else {
        tyreSizeTarget = jQuery(".inline-dosage-form .calc-desktop .calc-result-tyre-size");
    }

    let desTarget;
    if (type == "mobile") {
        desTarget = jQuery(".calc-mobile .calc-result-tyre-des");
    } else if (type == "sticky") {
        desTarget = jQuery(".calc-desktop.calc-desktop-sticky .calc-result-tyre-des");
    } else {
        desTarget = jQuery(".inline-dosage-form .calc-desktop .calc-result-tyre-des");
    }

    if ((tyreSize["ml"] && tyreSize["us-fl-oz"]) || (tyreSize["normal-dosage-litres"] && tyreSize["normal-dosage-us-quart"])) {
        if (tyreSize["severe-dosage-litres"] && tyreSize["severe-dosage-us-quart"]) {
            firstDosageTarget.find("span").html(firstDosageTarget.attr("data-normal-dosage"));
            firstVolumeTarget.html(tyreSize["result-normal-dosage"]);
        } else {
            firstDosageTarget.find("span").html(firstDosageTarget.attr("data-dosage"));
            firstVolumeTarget.html(tyreSize["result-dosage"]);
        }
    }
    if (tyreSize["severe-dosage-litres"] && tyreSize["severe-dosage-us-quart"]) {
        secondDosageTarget.html(firstDosageTarget.attr("data-severe-dosage") + ":");
        secondVolumeTarget.html(tyreSize["result-severe-dosage"]);
    }
    productTarget.html(tyreSize["result-product"]);
    rimSizeTarget.html(rimSizeSelect);
    tyreSizeTarget.html(tyreSizeSelect);
    desTarget.html(tyreSize["result-tyre-description"]);
}

// Calc select 2
function productTypeInitItems(data, productTypeSelect, rimSizeSelect, tyreSizeSelect) {
    // let data = window.dosageCalculatorData;
    // productTypeSelect.select2('destroy');
    // tyreSizeSelect.select2('destroy');

    productTypeSelect.html("");
    productTypeSelect.append("<option></option>");
    for (const item in data) {
        let option = '<option value="' + item + '" data-description="">' + item + "</option>";
        productTypeSelect.append(option);
    }
    productTypeSelect.select2({
        dropdownParent: productTypeSelect.parent(),
        dropdownCssClass: "select2-dropdown-custom",
        minimumResultsForSearch: Infinity,
        templateResult: formatOption,
        templateSelection: formatOptionSelection,
        dropdownPosition: "below",
        placeholder: productTypeSelect.attr("data-placeholder"),
    });

    rimSizeSelect.select2({
        dropdownParent: rimSizeSelect.parent(),
        dropdownCssClass: "select2-dropdown-custom",
        minimumResultsForSearch: Infinity,
        templateResult: formatOption,
        templateSelection: formatOptionSelection,
        dropdownPosition: "below",
        placeholder: tyreSizeSelect.attr("data-placeholder"),
    });

    tyreSizeSelect.select2({
        dropdownParent: tyreSizeSelect.parent(),
        dropdownCssClass: "select2-dropdown-custom",
        minimumResultsForSearch: Infinity,
        templateResult: formatOption,
        templateSelection: formatOptionSelection,
        dropdownPosition: "below",
        placeholder: tyreSizeSelect.attr("data-placeholder"),
    });
}
// Calc select
function productTypeInit(data) {
    if (data && Object.keys(data).length != 0) {
        //Desktop
        let productTypeSelect = jQuery("select[name='product-type-select']");
        let rimSizeSelect = jQuery("select[name='rim-size-select']");
        let tyreSizeSelect = jQuery("select[name='tyre-size-select']");
        productTypeInitItems(data, productTypeSelect, rimSizeSelect, tyreSizeSelect);

        //Inline
        let productTypeSelectInline = jQuery("select[name='inline-product-type-select']");
        let rimSizeSelectInline = jQuery("select[name='inline-rim-size-select']");
        let tyreSizeSelectInline = jQuery("select[name='inline-tyre-size-select']");
        productTypeInitItems(data, productTypeSelectInline, rimSizeSelectInline, tyreSizeSelectInline);

        //Mobile
        let productTypeSelectMobile = jQuery("select[name='mobile-product-type-select']");
        let rimSizeSelectMobile = jQuery("select[name='mobile-rim-size-select']");
        let tyreSizeSelectMobile = jQuery("select[name='mobile-tyre-size-select']");
        productTypeInitItems(data, productTypeSelectMobile, rimSizeSelectMobile, tyreSizeSelectMobile);

        calcEvents(data);
    }
}
function rimSizeInit(rimMap, type) {
    let rimSizeSelect;
    if (type == "sticky") {
        rimSizeSelect = jQuery(".calc-desktop-sticky select[name='rim-size-select']");
    } else if (type == "mobile") {
        rimSizeSelect = jQuery("select[name='mobile-rim-size-select']");
    } else {
        rimSizeSelect = jQuery(".inline-dosage-form select[name='inline-rim-size-select']");
    }

    rimSizeSelect.select2("destroy");
    rimSizeSelect.prop("disabled", false);
    rimSizeSelect.html("");
    rimSizeSelect.append("<option></option>");
    rimMap.forEach(function (item) {
        let option = '<option value="' + item + '" data-description="">' + item + "</option>";
        rimSizeSelect.append(option);
    });
    rimSizeSelect.select2({
        dropdownParent: rimSizeSelect.parent(),
        dropdownCssClass: "select2-dropdown-custom",
        minimumResultsForSearch: Infinity,
        templateResult: formatOption,
        templateSelection: formatOptionSelection,
        dropdownPosition: "below",
        placeholder: rimSizeSelect.attr("data-placeholder"),
    });
    rimSizeSelect.select2("open");
}
function tyreSizeInit(calc_data, type) {
    let tyreSizeSelect;
    if (type == "sticky") {
        tyreSizeSelect = jQuery(".calc-desktop-sticky select[name='tyre-size-select']");
    } else if (type == "mobile") {
        tyreSizeSelect = jQuery("select[name='mobile-tyre-size-select']");
    } else {
        tyreSizeSelect = jQuery(".inline-dosage-form select[name='inline-tyre-size-select']");
    }

    tyreSizeSelect.select2("destroy");
    tyreSizeSelect.prop("disabled", false);
    tyreSizeSelect.html("");
    tyreSizeSelect.append("<option></option>");
    calc_data.forEach(function (item) {
        let option = '<option value="' + item["tyre-size"] + '" data-description="">' + item["tyre-size"] + "</option>";
        tyreSizeSelect.append(option);
    });
    tyreSizeSelect.select2({
        dropdownParent: tyreSizeSelect.parent(),
        dropdownCssClass: "select2-dropdown-custom",
        minimumResultsForSearch: Infinity,
        templateResult: formatOption,
        templateSelection: formatOptionSelection,
        dropdownPosition: "below",
        placeholder: tyreSizeSelect.attr("data-placeholder"),
    });
    tyreSizeSelect.select2("open");
}

function checkInlineDosageFormVisibility() {
    // Check if .inline-dosage-form element exists
    var $inlineDosageForm = $(".inline-dosage-form");
    var $calcDesktop = $(".calc-desktop.calc-desktop-sticky");

    if ($inlineDosageForm.length > 0) {
        var elementTop = $inlineDosageForm.offset().top;
        var elementBottom = elementTop + $inlineDosageForm.outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        // Check if element is visible in viewport
        var isVisible = elementBottom > viewportTop && elementTop < viewportBottom;

        if (isVisible) {
            $calcDesktop.addClass("is-hidden");
        } else {
            $calcDesktop.removeClass("is-hidden");
        }
    }
}

$(document).ready(function () {
    // testCalcDescription();các
    checkInlineDosageFormVisibility();
    // Add animation for grid items from left to right
    if (jQuery(".owl-custom-text-section").length) {
        jQuery(".owl-custom-text-section").each(function () {
            let gridItems = jQuery(this).find(".owl-custom-text-grid-item");
            let bottomText = jQuery(this).find(".owl-section-text-des");

            // Create timeline for grid items
            let tlGrid = gsap.timeline({ paused: true });

            if (gridItems.length) {
                // Add animation - fade in and slide from left to right
                tlGrid.from(gridItems, {
                    opacity: 0,
                    x: -30,
                    duration: 0.6,
                    ease: "power2.out",
                    stagger: { amount: 0.8 }, // Time between each item animation
                });

                if (bottomText.length) {
                    // Then animate the bottom text
                    tlGrid.from(
                        bottomText,
                        {
                            opacity: 0,
                            y: 20, // Start from below
                            duration: 0.8,
                            ease: "power2.out",
                        },
                        "-=0.3",
                    ); // Start slightly before the last grid item finishes
                }

                // Create ScrollTrigger for the timeline
                ScrollTrigger.create({
                    trigger: jQuery(this).find(".owl-custom-text-grid"),
                    start: "top 70%",
                    onEnter: () => tlGrid.play(),
                });

                // Reset timeline when scrolled out of view
                ScrollTrigger.create({
                    trigger: jQuery(this).find(".owl-custom-text-grid"),
                    start: "top bottom",
                    onLeaveBack: () => {
                        tlGrid.progress(0);
                        tlGrid.pause();
                    },
                });
            }
        });

        // Set initial opacity to 0 for grid items
        if (jQuery(".owl-custom-text-grid-item").length) {
            gsap.set([".owl-custom-text-grid-item"], { opacity: 0 });
        }

        if (jQuery(".owl-custom-text-section .owl-section-text-des").length) {
            gsap.set([".owl-custom-text-section .owl-section-text-des"], {
                opacity: 0,
            });
        }
    }
});
function productSliderHeight() {
    jQuery(".oko-products-slider-main-inner").each(function () {
        let obj = jQuery(this);
        setTimeout(() => {
            let height = obj.height();
            obj.attr("style", "--product-slider-height:" + height + "px");
        }, 1000);
    });
}
function freeSliderItemWidth() {
    setTimeout(() => {
        jQuery(".oko-free-images-slider-item").each(function () {
            let obj = jQuery(this);
            let width = obj.find(".apply-images-slider-image img").width();
            obj.attr("style", "--item-image-width:" + width + "px");
            jQuery(this).addClass("is-loaded");
        });
    }, 200);
}

$(document).ready(function () {
    productSliderHeight();
    // freeSliderItemWidth();
    if (jQuery(".oko-history-section").length) {
        // Register ScrollTrigger plugin (uncomment if needed)
        // gsap.registerPlugin(ScrollTrigger);

        // Initially hide all timeline items
        gsap.set(".timeline-container", { autoAlpha: 0, y: 50 });

        // Create animations for each timeline container
        $(".timeline-container").each(function (index) {
            let container = $(this);

            // Create a timeline for each container with scroll trigger
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    start: "top 75%", // Trigger when the top of container reaches 75% of viewport
                    end: "bottom 25%",
                    toggleActions: "play none none reverse", // play on enter, reverse on leave
                    markers: false, // Set to true for debugging scroll positions
                },
            });

            // Year animation - slide in from left
            tl.fromTo(container.find(".custom-timeline-year"), { autoAlpha: 0, x: -50 }, { duration: 0.6, autoAlpha: 1, x: 0, ease: "power2.out" });

            // Description animation - fade up
            tl.fromTo(
                container.find(".custom-timeline-des"),
                { autoAlpha: 0, y: 30 },
                { duration: 0.5, autoAlpha: 1, y: 0, ease: "power1.out" },
                "-=0.3", // Start slightly before previous animation ends (overlap)
            );

            // Image animation - scale up with bounce effect
            tl.fromTo(
                container.find(".custom-timeline-thumb"),
                { autoAlpha: 0, scale: 0.8 },
                {
                    duration: 0.7,
                    autoAlpha: 1,
                    scale: 1,
                    ease: "back.out(1.2)",
                },
                "-=0.3", // Overlap with previous animation
            );

            // Make container visible at the start of animations
            tl.to(container, { autoAlpha: 1, y: 0, duration: 0.1 }, 0);
        });

        // Special animation for the full-width container (2014 with map)
        let fullContainer = $(".timeline-container-full");
        if (fullContainer.length) {
            let specialTl = gsap.timeline({
                scrollTrigger: {
                    trigger: fullContainer,
                    start: "top 60%", // Slightly different trigger point
                    end: "bottom 20%",
                    toggleActions: "play none none reverse",
                    markers: false,
                },
            });

            // Special elastic animation for the map image
            specialTl.fromTo(
                fullContainer.find(".custom-timeline-image"),
                { autoAlpha: 0, scale: 0.9 },
                {
                    duration: 1.2,
                    autoAlpha: 1,
                    scale: 1,
                    ease: "elastic.out(1, 0.5)", // Elastic bounce effect for the map
                },
                0.5, // Delay start by 0.5 seconds
            );
        }

        // Main title animation - fade in from top
        gsap.from(".oko-history-title", {
            scrollTrigger: {
                trigger: ".oko-history-section",
                start: "top 80%", // Trigger when section is 80% in view
                toggleActions: "play none none none", // Play once and don't reverse
            },
            y: -50, // Start 50px above final position
            autoAlpha: 0,
            duration: 1,
            ease: "power2.out", // Smooth easing
        });
    }
});

$(document).ready(function () {
    jQuery(".oko-testimonial-slider").each(function (index, element) {
        let okoTestimonialSliderCount = jQuery(element).find(".oko-testimonial-item").length;
        const okoTestimonialSlider = new Swiper(element, {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            spaceBetween: 24,
            autoHeight: false,
            // If we need pagination
            pagination: {
                el: jQuery(element).find(".swiper-pagination")[0],
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: okoTestimonialSliderCount >= 2 ? 2 : okoTestimonialSliderCount,
                },
                1024: {
                    slidesPerView: okoTestimonialSliderCount >= 3 ? 3 : okoTestimonialSliderCount,
                },
            },
        });
    });

    jQuery(".oko-apply-slider").each(function (index, element) {
        let okoApplySliderCount = jQuery(element).find(".oko-apply-item").length;
        const okoApplySlider = new Swiper(element, {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            spaceBetween: 24,
            autoHeight: false,
            // If we need pagination
            pagination: {
                el: jQuery(element).find(".swiper-pagination")[0],
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: okoApplySliderCount >= 2 ? 2 : okoApplySliderCount,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: okoApplySliderCount >= 2 ? 2 : okoApplySliderCount,
                    spaceBetween: 60,
                },
                1200: {
                    slidesPerView: okoApplySliderCount >= 2 ? 2 : okoApplySliderCount,
                    spaceBetween: 90,
                },
                1440: {
                    slidesPerView: okoApplySliderCount >= 3 ? 3 : okoApplySliderCount,
                    spaceBetween: 120,
                },
                1640: {
                    slidesPerView: okoApplySliderCount >= 3 ? 3 : okoApplySliderCount,
                    spaceBetween: 180,
                },
            },
        });
    });
    jQuery(".oko-products-slider").each(function (index, element) {
        const okoProductsSlider = new Swiper(element, {
            // Optional parameters
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 24,
            autoHeight: false,
            centeredSlides: true,
            // If we need pagination
            navigation: {
                nextEl: jQuery(element).parents(".oko-products-slider-section").find(".swiper-button-next")[0],
                prevEl: jQuery(element).parents(".oko-products-slider-section").find(".swiper-button-prev")[0],
            },
            pagination: {
                el: jQuery(element).parents(".oko-products-slider-section").find(".swiper-pagination")[0],
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
                1640: {
                    slidesPerView: 3,
                    spaceBetween: 44,
                },
            },
        });
    });

    jQuery(".oko-free-images-slider:not(.init-later)").each(function (index, element) {
        const okoFreeImagesSlider = new Swiper(element, {
            // Optional parameters
            loop: false,
            slidesPerView: "auto",
            // freeMode: true,
            spaceBetween: 20,
            autoHeight: false,
            // If we need pagination
            pagination: {
                el: jQuery(element).parents(".oko-free-images-slider-outer").find(".swiper-pagination")[0],
                clickable: true,
            },
            navigation: {
                nextEl: jQuery(element).parents(".oko-free-images-slider-outer").find(".swiper-button-next")[0],
                prevEl: jQuery(element).parents(".oko-free-images-slider-outer").find(".swiper-button-prev")[0],
            },
            on: {
                afterInit: function () {
                    freeSliderItemWidth();
                },
                resize: function () {
                    freeSliderItemWidth();
                },
            },
        });
    });
});

jQuery(window).resize(function () {
    productSliderHeight();
    // freeSliderItemWidth();
    checkInlineDosageFormVisibility();
});

// Run on scroll
$(window).scroll(function () {
    checkInlineDosageFormVisibility();
});
